import type { ThemeMode } from '@/hooks/useLightMode'

/**
 * Resolves a dark-package semantic color token for the active color scheme.
 * Settings section content renders inside the shell's single `DarkProvider`,
 * where light-mode tokens live under a `light.` namespace. Typography
 * (`textStyle`) tokens are mode-agnostic and never need prefixing.
 *
 * The single source of truth consumed by `SettingsShell` and every section
 * feature (via the `@/features/settings` barrel) so the mapping stays in one
 * place.
 */
export const settingsColorToken = (colorScheme: ThemeMode, token: string) =>
  colorScheme === 'light' ? `light.${token}` : token

// Dark `text.secondary` lacks contrast against `bg.card`.
export const settingsStateBodyTextColorToken = (colorScheme: ThemeMode) =>
  colorScheme === 'light'
    ? settingsColorToken(colorScheme, 'text.secondary')
    : settingsColorToken(colorScheme, 'text.input-value')

export const settingsTableStateTextColorToken = (colorScheme: ThemeMode) =>
  colorScheme === 'light'
    ? settingsColorToken(colorScheme, 'text.primary')
    : settingsStateBodyTextColorToken(colorScheme)
